module.exports = __webpack_public_path__ + "media/images/admin/icons/x-square-b8dd0ce607bca97aa45c2bba49b76ea1.svg";